import type { Order } from '@hero/schema';

/** After this long in `generating` with no completion, treat the job as dead. */
export const WAYBILL_GENERATING_STALE_MS = 5 * 60 * 1000;

/**
 * Whether Hero's async PDF waybill job is probably stuck.
 *
 * Uses `doc.updatedAt` — the order row changes when we mark `generating`, and
 * again when the job finishes or fails. A long gap means the worker died.
 */
export const isWaybillGenerationStale = (order: Pick<Order, 'waybill' | 'doc'>): boolean => {
  if (order.waybill?.status !== 'generating') return false;
  const updatedAt = order.doc?.updatedAt;
  if (!updatedAt) return true;
  return Date.now() - new Date(updatedAt).getTime() > WAYBILL_GENERATING_STALE_MS;
};
